export default "__VITE_ASSET__DWy61UFj__"